import { render, staticRenderFns } from "./Trainee.vue?vue&type=template&id=33915ee7"
import script from "./Trainee.vue?vue&type=script&lang=js"
export * from "./Trainee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports